import script from "./ProgParentEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgParentEdit.vue?vue&type=script&setup=true&lang=js"

import "./ProgParentEdit.vue?vue&type=style&index=0&id=64d744d8&lang=scss"

const __exports__ = script;

export default __exports__